import React, { useEffect, useState } from 'react';

function RegistrationEntry({ product, updateEntry, removeEntry, translations, keyName, onChangeEntry }) {
  const [showSerialNumberModal, setShowSerialNumberModal] = useState(false);
  const [serialNumberHtml, setSerialNumberHtml] = useState('');

  const uniqueKey = 'reg-' + product.PimId.replaceAll(/\s/g, '');
  const openSerialNumberPlacement = () => {
    const productSerialNumberHtmlApiUrl =
      '/api/sitecore/SalesforceProductRegistration/GetProductSerialNumberHtml' +
      '?subcategoryPimId=' +
      product.Canonical;
    fetch(productSerialNumberHtmlApiUrl, { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((data) => {
        setSerialNumberHtml(data.length > 0 ? data : translations.DefaultSerialNumberHtml);
        setShowSerialNumberModal(true);
      })
      .catch((e) => e);
  };

  const initZoomImg = () => {
    'use strict';

    var CUR_ZI = 'zoom-in';
    var CUR_ZO = 'zoom-out';

    var imgContainers = document.querySelectorAll('#' + uniqueKey + ' .registrationEntry__imageContainer');

    imgContainers.forEach(function (imgContainer) {
      var img = imgContainer.querySelector('img.registrationEntry__productImage');
      var dataset = imgContainer.dataset;

      if (img) {
        imgContainer.style.cursor = CUR_ZI;
        imgContainer.style.overflow = 'hidden';

        img.addEventListener('mousemove', function (e) {
          var x = e.layerX;
          var y = e.layerY;
          var w = img.offsetWidth;
          var h = img.offsetHeight;
          var originX = (x / w) * 100;
          var originY = (y / h) * 100;

          if (originX > 100) originX = 50;
          if (originY > 100) originY = 50;
          img.style.transformOrigin = originX + '% ' + originY + '%';
        });

        imgContainer.addEventListener('click', function () {
          var maxValue = parseInt(dataset.zoomMax || 1) + 1;
          var currValue = parseInt(dataset.zoomValue || 1);
          var nextValue = currValue + 1;

          if (nextValue > maxValue) {
            img.style.transform = 'scale(1)';
            imgContainer.style.cursor = CUR_ZI;
            imgContainer.setAttribute('data-zoom-value', '1');
          } else {
            img.style.transform = 'scale(' + nextValue + ')';
            imgContainer.setAttribute('data-zoom-value', nextValue);

            if (nextValue === maxValue) {
              imgContainer.style.cursor = CUR_ZO;
            }
          }
        });
      }
    });
  };

  useEffect(() => {
    initZoomImg();
  }, []);

  const setSerialNumber = (e) => {
    const serialNumber = e.target.value?.trim();
    if (serialNumber) {
      product.serialNumber = serialNumber;
      updateEntry(product, keyName);
    } else {
      e.target.value = '';
    }
  };
  const setKeyNumber = (keyNumber) => {
    product.keyNumber = keyNumber;
    updateEntry(product, keyName);
  };

  return (
    <>
      {!product.collapse ? (
        <div key={uniqueKey} id={uniqueKey} className="sfpr__registrationEntry col-12">
          <div
            className={
              'sfpr__serialnumber left-slide-in-menu-wrapper' + (showSerialNumberModal ? '' : ' wrapper-hidden')
            }
          >
            <div className="menu-content-section">
              <div className="menu-buttons">
                <button aria-label="close" type="button" onClick={(e) => setShowSerialNumberModal(false)}>
                  <span className="d-none">Close</span>
                  <span className="arrow-icon">
                    <i className="fas fa-times"></i>
                  </span>
                </button>
              </div>
              <div className="sfpr__serialnumber__html " dangerouslySetInnerHTML={{ __html: serialNumberHtml }} />
            </div>
          </div>
          <div data-zoom-max="2" className="d-flex justify-content-center registrationEntry__imageContainer">
            <img src={product.ProductImage} alt={product.Name} className="registrationEntry__productImage" />
          </div>
          <span className="heading6 d-block mt-2">
            {product.Name}
            {product.Webtitle2 && ' - ' + product.Webtitle2}
          </span>
          <span className="d-block mb-3">
            <button className="btn--change" type="button" onClick={() => onChangeEntry(keyName)}>
              <span>{translations.Change}</span>
            </button>
          </span>
          <span className="heading6 d-block mb-3">{translations.ProductInformation}</span>
          <div className="sfpr__inputField">
            <label htmlFor="serialNumber">{translations.SerialNumber} *</label>
            <input
              onChange={(e) => setSerialNumber(e)}
              className="d-block"
              type="text"
              name="serialNumber"
              id="serialNumber"
              required
            ></input>
            <a onClick={openSerialNumberPlacement} href="#">
              {translations.FindSerialNumber}
            </a>
          </div>
          <div className="sfpr__inputField">
            <label htmlFor="keyNumber">{translations.KeyNumber}</label>
            <input
              onChange={(e) => setKeyNumber(e.target.value)}
              className="d-block"
              type="text"
              name="keyNumber"
              id="keyNumber"
              placeholder="N104"
            ></input>
          </div>
        </div>
      ) : (
        <div key={'reg' + product.PimId} className="sfpr__registrationEntry--collapsed">
          <div>
            <span className="fw-bold d-block">
              {product.Name}
              {product.Webtitle2 && ' - ' + product.Webtitle2}
            </span>
            <span>SN: {product.serialNumber}</span>
          </div>
          <div>
            <button className="btn--remove" onClick={() => removeEntry(keyName)}>
              <i size="25" className="fas fa-trash-alt link"></i>
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default RegistrationEntry;
